export default "__VITE_ASSET__C4EAG2XU__"